// Client-side mirrors of backend validation rules
// (app/utils/israeli_validation.py) - source of truth is the backend.

export function normalizeIsraeliId(value: string): string | null {
  const clean = value.replace(/\D/g, '');
  if (!clean || clean.length > 9) return null;
  return clean.padStart(9, '0');
}

export function isValidIsraeliId(value: string): boolean {
  const normalized = normalizeIsraeliId(value);
  if (!normalized) return false;
  let total = 0;
  for (let i = 0; i < 9; i++) {
    let step = parseInt(normalized[i], 10) * (1 + (i % 2));
    if (step >= 10) step -= 9;
    total += step;
  }
  return total % 10 === 0;
}

export function isValidObligation(value: string): boolean {
  return /^\d{9}$/.test(value.trim());
}

export function isValidIsraeliMobile(value: string): boolean {
  let clean = value.replace(/[^\d+]/g, '');
  if (clean.startsWith('+972')) clean = '0' + clean.slice(4);
  else if (clean.startsWith('972')) clean = '0' + clean.slice(3);
  return /^05\d{8}$/.test(clean);
}
